import { CoursesHeaderCombinedProps } from './types';

const usePresenter = (props: CoursesHeaderCombinedProps): CoursesHeaderCombinedProps => {
  return props;
};

export default usePresenter;
